"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rel8n = void 0;
/**
 * Convenience enum to avoid spelling mistakes. (optional)
 */
var Rel8n;
(function (Rel8n) {
    Rel8n["past"] = "past";
    Rel8n["ancestor"] = "ancestor";
    Rel8n["dna"] = "dna";
    Rel8n["identity"] = "identity";
    Rel8n["tjp"] = "tjp";
})(Rel8n = exports.Rel8n || (exports.Rel8n = {}));
